import { DatabaseRecord, DatabaseRecordData, DatabaseType } from './database-record.class';

export type Identifier = string;
export type Version = number;
export type HexColor = string;

export interface Record {
  id: Identifier;
  name: string;
}

export interface Param {
  values: string[] | number[] | object[];
  type: string;
}

export interface DocumentRecordData<T> extends DatabaseRecordData {
  version: number;
  document: T;
}

export class DocumentRecord<T> extends DatabaseRecord implements DocumentRecordData<T> {
  static fields = ['version', 'userUUID', 'document'];

  static databaseType = DatabaseType.Document;

  version: number;
  userUUID: string;
  document: T;

  constructor(data?: DocumentRecordData<T>) {
    super(data);
    this.version = data.version;
    this.document = data.document;
  }
}
